import { supabase } from './supabase';
import { SUPABASE_URL } from '../utils/constants';

export interface SuggestSupplierRiskBody {
  supplierName?: string;
  location?: string;
  newsSnippet?: string;
  existingRiskScores?: Record<string, number>;
  suggestMitigationsOnly?: boolean;
  supplierId?: string;
}

export interface SuggestedOutput {
  risk_scores?: Record<string, number>;
  overall_score?: number;
  outlook?: string;
  actions?: string;
  mitigation_tasks?: Array<{ task: string; status: string; priority: string }>;
}

export async function invokeSuggestSupplierRisk(
  body: SuggestSupplierRiskBody
): Promise<{ suggested: SuggestedOutput }> {
  const {
    data: { session },
    error: sessionError,
  } = await supabase.auth.getSession();
  if (sessionError || !session?.access_token) {
    throw new Error('Not authenticated. Please sign in again.');
  }
  const url = `${SUPABASE_URL}/functions/v1/suggest-supplier-risk`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error ?? res.statusText ?? 'AI suggestion failed. Configure AI in AI Settings.';
    throw new Error(message);
  }
  return data as { suggested: SuggestedOutput };
}
